// Shared accent mapping for monthly report cards and report heroes.
const REPORT_GRADIENT_ACCENT_FAMILIES = [
    'red',
    'orange',
    'amber',
    'yellow',
    'lime',
    'green',
    'emerald',
    'cyan',
    'sky',
    'blue',
    'violet',
    'pink',
];
export const getReportGradientAccentFamily = (reportMonth) => {
    const reportMonthMatch = reportMonth?.match(/^(\d{4})-(\d{2})$/);
    const monthIndex = reportMonthMatch
        ? Number.parseInt(reportMonthMatch[2], 10) - 1
        : undefined;
    if (typeof monthIndex === 'number' && monthIndex >= 0 && monthIndex <= 11) {
        return REPORT_GRADIENT_ACCENT_FAMILIES[11 - monthIndex];
    }
    return REPORT_GRADIENT_ACCENT_FAMILIES[0];
};
//# sourceMappingURL=reportAccents.js.map